<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">訂單管理 / 訂單查詢</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px" visible>
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">品牌：</label>
                  <div class="col-md-4">
                    <select
                      name="queryBrandsCode"
                      class="form-control"
                      v-model="queryBrandsCode"
                    >
                    <option
                      v-for="x in selectListBrands"
                      v-bind:value="x.Code"
                      :key="x.Code"
                    >{{x.Text}}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">訂餐日期：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="sdate">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="edate">
                  </div>
                  <label class="mt-2">(日期區間可篩選15日)</label>
                </div>
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">取餐日期：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="sdate_take">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="edate_take">
                  </div>
                  <label class="mt-2">(日期區間可篩選15日)</label>
                </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">門市：</label>
                <div class="col-md-4">
                  <multiselect v-model="store" :options="storelist" :multiple="false" :custom-label="nameWithLang" placeholder="請選擇" label="Name" track-by="Name" selectLabel="">
                    <span slot="noResult">查無資料</span>
                  </multiselect>
                </div>
                <label class="control-label col-md-2 mt-2 text-right">付款方式：</label>
                <div class="col-md-4">
                  <select id="payment" name="payment" class="form-control" v-model="paymenttype">
                          <option v-bind:value="0" :key="0">全部</option>
                          <option v-for="x in paymenttypeList" v-bind:value="x.ID" :key="x.ID">{{x.Text}}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">訂單狀態：</label>
                <div class="col-md-4">
                  <select class="form-control" id="processtype" name="processtype" v-model="processtype">
                          <option v-bind:value="0" :key="0">全部</option>
                          <option v-bind:value="6" :key="6">支付進行中</option>
                          <option v-bind:value="2" :key="2">完成</option>
                          <option v-bind:value="4" :key="4">失敗</option>
                          <option v-bind:value="5" :key="5">已退貨</option>
                  </select>
                </div>
                <label class="control-label col-md-2 mt-2 text-right">付款狀態：</label>
                <div class="col-md-4">
                  <select class="form-control" v-model="payed">
                        <option value="0">全部</option>
                        <option value="">未付款</option>
                        <option value="1">已付款</option>
                        <option value="2">已退款</option>
                        <option value="3">臨櫃未取貨</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">手機：</label>
                <div class="col-md-4">
                  <input type="mobile" class="form-control" id="mobile" placeholder="請輸入手機號碼" v-model="mobile">
                </div>
                <label class="control-label col-md-2 mt-2 text-right">訂單編號：</label>
                <div class="col-md-4">
                  <input type="text" class="form-control" id="ordercode" placeholder="請輸入訂單編號" v-model="ordercode">
                </div>
              </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">用餐方式：</label>
                <div class="col-md-4">
                  <select class="form-control" v-model="takeType">
                        <option value="0">全部</option>
                        <option value="">外帶</option>
                        <option value="1">內用</option>
                  </select>
                </div>
                <label class="control-label col-md-2 mt-2 text-right">餐期：</label>
                <div class="col-md-4">
                  <select id="period" class="form-control" v-model="periodID">
                          <option v-bind:value="0" :key="0">全部</option>
                          <option v-for="x in periodList" v-bind:value="x.ID" :key="x.ID">{{x.Desc}}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">取餐編號：</label>
                <div class="col-md-4">
                  <input type="takeNumber" class="form-control" id="takeNumber" placeholder="請輸入取餐編號" v-model="takeNumber">
                </div>
              </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right"></label>
                <div class="col-md-3">
                </div>
                <div class="col-lg-6 mt-2 text-right">
                    <button type="button" class="btn btn-warning text-white" @click="btnQuery()">查詢</button>
                </div>
              </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <table id="mytable" class="table table-bordred table-striped">
              <thead>
                <tr>
                  <th width="60px">序號</th>
                  <th>訂單編號</th>
                  <th>取餐編號</th>
                  <th>餐期<br/>用餐方式</th>
                  <th>手機<br/>姓名</th>
                  <th>門市</th>
                  <th>訂餐時間<br/>取餐時間</th>
                  <th>付款方式</th>
                  <th>金額</th>
                  <th>訂單狀態</th>
                  <th>付款狀態</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(x,index) in orderlist" :key="x.ID">
                  <td>
                      <span class="font-center" >{{((currentPage-1)*perpage+index+1)}}</span>
                  </td>
                  <td>{{x.Code}}</td>
                  <td>{{x.TakeNumber}}</td>
                  <td>{{x.PeriodDesc}}<br/>{{x.TakeType}}</td>
                  <td>{{x.Mobile}}<br/>{{x.UserName}}</td>
                  <td>{{x.StoreName}}</td>
                  <td>{{x.OrderAt}}<br />{{x.TakeAt}}</td>
                  <td>{{x.PaymentType}}</td>
                  <td>{{x.Total}}</td>
                  <td>{{x.ProcessType}}</td>
                  <td>{{x.Payed}}</td>
                  <td class="title">
                    <button v-b-tooltip.hover.top title="訂單明細" class="btn-circle btn-circle-ptc1" @click="showMeal(x.Code)"><span class="far fa-list-alt"></span></button>
                    <button v-b-tooltip.hover.top title="預覽" class="btn-circle btn-circle-ptc1" @click="showDetail(x)" v-if="x.Payed=='已退款'||x.ErrorMemo!=''||x.ErrMemo!=''||x.ProcessType.substr(0,3)=='已退貨'"><span class="fa fa-search-plus"></span></button>
                    <button class='btn btn-outline-light' @click="showEdit(x)"
                    v-if="( (new Date().getHours()>=15 && x.Today==x.OrderAt.substr(0,10) && x.OrderType=='')
                            ||(x.ErrorMemo.indexOf('已入機POS')!=-1 && x.Today==x.TakeAt.substr(0,10) && x.OrderType=='1')
                            ||(x.TakeAt.substr(0,10)<x.Today && x.Diffdays>=-60))
                          &&(x.ProcessType=='完成' && x.Payed=='已付款' && x.PaymentType!='臨櫃付款' && FunctionPermission === 4)">退款</button>
                    <button class='btn btn-outline-light' @click="showEditCancel(x)"
                    v-if="(x.ProcessType=='完成'
                           && ((x.PaymentType != '臨櫃付款' && x.Payed=='已付款') || ((x.PaymentType == '臨櫃付款'||x.PaymentType == '無須付款') && x.Payed == '未付款'))
                           && FunctionPermission === 4
                           && x.OrderType=='1'
                           && x.Today<=x.TakeAt.substr(0,10) )">取消</button>
                  </td><!-- 非預約單：當日的訂單15點後才可退款，可退60天內的訂單 -->
<!--
1. 非預約單維持現狀，15點以後才可以退款
2. 預約單
   取餐日>今天的預約單可以取消
   取餐日=今天的預約單可以取消，但如果已入機就會回覆已入機，按鈕改成[退款]
   取餐日<今天的預約單只可退款 -->
                </tr>
              </tbody>
            </table>
            <div class="row" style="padding: 0 1rem">
              <b-pagination size="md" :total-rows="count" v-model="currentPage" :per-page="perpage" @change="changePage"></b-pagination>
              <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{count}}筆</label>
            </div>
          </div>
        </div>
      </b-card>
      <!-- 編輯畫面Modal -->
      <b-modal ref="mdEdit" hide-footer size='lg' :title='md_item.refundTitle'>
        <b-container fluid>
          <div class="row">
            <div class="col-lg-12">
              <div class='row mb-3' style="text-align:center">
                <label class='control-label col-md-12' style="color:blue;font-weight:bold">
                  僅處理退款、扣回訂單累積點數及退回使用票券對應點數；<br />
                  不會傳送取消訂單給POS<br />
                  (不包含臨櫃付款的退款，須請門市退款給會員)</label>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>退款原因：</label>
                  <div class='col-md-7'>
                    <textarea rows='4' class='form-control resize_vertical' id='reason' name='reason' v-model='md_item.refundMemo' placeholder='請輸入50字內' ></textarea>
                    <div class="text-danger" v-if="valid_memo&&!md_item.refundMemo">{{valid_memo}}</div>
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>輸入登入密碼：</label>
                  <div class='col-md-7'>
                    <input type='password' class='form-control' v-model.trim='md_item.password' placeholder='請輸入密碼' maxlength="50" >
                    <div class="text-danger" v-if="valid_password&&!md_item.password">{{valid_password}}</div>
                  </div>
              </div>
            </div>
            <div class="col-lg-12">
                    <div class="row float-right cog-lg-12">
                        <b-btn variant="primary" @click="editConfirm('')">確認</b-btn>&nbsp;
                        <b-btn variant="secondary" @click="editClose()">取消</b-btn>&nbsp;
                    </div>
            </div>
          </div>
        </b-container>
      </b-modal>
      <b-modal ref="mdEditCancel" hide-footer size='lg' :title='md_item.refundTitle'>
        <b-container fluid>
          <div class="row">
            <div class="col-lg-12">
              <div class='row mb-3' style="text-align:center">
                <label class='control-label col-md-12' style="color:blue;font-weight:bold">
                  將傳送取消訂單給POS，並處理退款、扣回訂單累積點數及退回使用票券對應點數。</label>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>取消原因：</label>
                  <div class='col-md-7'>
                    <textarea rows='4' class='form-control resize_vertical' id='reason' name='reason' v-model='md_item.refundMemo' placeholder='請輸入50字內' ></textarea>
                    <div class="text-danger" v-if="valid_memo&&!md_item.refundMemo">{{valid_memo}}</div>
                  </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>輸入登入密碼：</label>
                  <div class='col-md-7'>
                    <input type='password' class='form-control' v-model.trim='md_item.password' placeholder='請輸入密碼' maxlength="50" >
                    <div class="text-danger" v-if="valid_password&&!md_item.password">{{valid_password}}</div>
                  </div>
              </div>
            </div>
            <div class="col-lg-12">
                    <div class="row float-right cog-lg-12">
                        <b-btn variant="primary" @click="editConfirm('1')">確認</b-btn>&nbsp;
                        <b-btn variant="secondary" @click="editCancelClose()">取消</b-btn>&nbsp;
                    </div>
            </div>
          </div>
        </b-container>
      </b-modal>
      <!-- 編輯畫面Modal -->
      <b-modal ref="mdDetail" hide-footer size='lg' :title='md_detail.detailTitle'>
        <b-container fluid>
          <div class="row">
            <div class="col-lg-12">
              <div class='row mb-12' v-if="md_detail.Payed=='已退款'||md_detail.RefundBy!==0">
                <label class='control-label col-md-2'>退款時間：</label>
                  <div class='col-md-8'>{{md_detail.RefundTime|formatFullDate}}</div>
              </div>
              <div class='row mb-12' v-if="md_detail.Payed=='已退款'||md_detail.RefundBy!==0">
                <label class='control-label col-md-2'>退款來源：</label>
                  <div class='col-md-4'>{{md_detail.RefundFrom}}</div>
                <label class='control-label col-md-2' v-if="md_detail.RefundBy!=''">人員：</label>
                  <div class='col-md-4'>{{md_detail.RefundBy}}</div>
              </div>
              <div class='row mb-12' v-if="md_detail.Payed=='已退款'||md_detail.RefundBy!==0">
                <label class='control-label col-md-2'>退款原因：</label>
                  <div class='col-md-8'>{{md_detail.RefundMemo}}</div>
              </div>
              <div class='row mb-12' v-if="md_detail.ErrorMemo!=''">
                <label class='control-label col-md-2'>失敗原因：</label>
                  <div class='col-md-8'>{{md_detail.ErrorMemo}}</div>
              </div>
            </div>
            <div class="col-lg-12">
                    <div class="row float-right cog-lg-12">
                        <b-btn variant="secondary" @click="detailCancel()">關閉</b-btn>&nbsp;
                    </div>
            </div>
          </div>
        </b-container>
      </b-modal>
      <!-- 訂單明細-->
      <b-modal ref="mdMeal" hide-footer size='lg' :title="'訂單明細 - ' + md_meal.code">
        <b-container fluid>
          <div class="row">
            <div class="col-lg-12">
              <div class='row mb-12'>
                <label class='control-label col-md-2'>取餐編號：</label>
                  <div class='col-md-10'>{{md_meal.num}}</div>
              </div>
              <div class='row mb-12'>
                <label class='control-label col-md-2'>訂單內容：</label>
              </div>
              <div class='row mb-12'>
                <div class="col-md-2"></div>
                <div class='col-md-10'>
                <table class='col-md-10'>
                  <tr v-for="x in md_meal.detail" :key="x.ID">
                    <td class="text-top">{{x.qty}}X．</td>
                    <td>
                      {{ x.name }}
                      <span v-if="x.promoCode != ''" style="font-size: small; color: green">
                        優惠碼:{{ x.promoCode }}
                      </span>
                      <span v-else-if="x.posDiscountCode != '' && x.freebieBalance > -1" style="color: green">
                        贈品
                      </span>
                      <li v-for="y in x.sideMeal" :key="y.ID">
                        {{y.name}}(+${{y.price}})<label v-for="ya in y.add" :key="ya.ID">-{{ya.name}}(+${{ya.price}})</label>
                      </li>
                      <li v-for="y in x.add" :key="y.ID">
                        {{y.name}} {{y.type==2 ? '(+$'+y.price+')' : ''}}
                      </li>
                      <div v-for="y in x.link" :key="y.ID">
                        加價購 - {{y.name}} (+${{y.price}})
                        <li v-for="z in y.sideMeal" :key="z.ID">
                          {{z.name}}(+${{z.price}})<label v-for="ya in z.add" :key="ya.ID">-{{ya.name}}(+${{ya.price}})</label>
                        </li>
                        <li v-for="z in y.add" :key="z.ID">
                          {{z.name}} {{z.type==2 ? '(+$'+z.price+')' : ''}}
                        </li>
                      </div>
                      <li style="list-style-type:none;" v-if="x.useCoupon">優惠兌換券</li>
                    </td>
                    <td class="text-right text-top">${{x.price}}</td>
                  </tr>
                  <tr><td colspan="3"> <hr></td></tr>
                  <tr>
                    <td colspan="2">小計：</td>
                    <td class='text-right'>${{md_meal.subTotal}}</td>
                  </tr>
                  <tr v-for="x in md_meal.discountList" :key="`${x.id}${x.type}`" style="color:gray">
                    <td colspan="2">{{x.name}}</td>
                     <td v-if="x.price != 0" class="text-right">-${{ x.price }}</td>
                  </tr>
                  <tr v-if="md_meal.bonusDiscount != 0" style="color:gray">
                    <td colspan="2">點數折抵：</td>
                    <td class='text-right'>-${{md_meal.bonusDiscount}}</td>
                  </tr>
                  <tr v-if="md_meal.deltaDiscount != 0" style="color:gray">
                    <td colspan="2">線下折抵：</td>
                    <td class='text-right'>-${{md_meal.deltaDiscount}}</td>
                  </tr>
                  <tr v-if="md_meal.discount != 0 || md_meal.bonusDiscount != 0 || md_meal.deltaDiscount != 0">
                    <td colspan="2">總共折抵：</td>
                    <td class='text-right'>-${{md_meal.discount + md_meal.bonusDiscount + md_meal.deltaDiscount}}</td>
                  </tr>
                  <tr>
                    <td colspan="2">總計：</td>
                    <td class='text-right'>${{md_meal.total}}</td>
                  </tr>
                </table>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="row float-right cog-lg-12">
                <b-btn variant="secondary" @click="$refs.mdMeal.hide()">關閉</b-btn>
              </div>
            </div>
          </div>
        </b-container>
      </b-modal>
    </div>
  </div>
</template>
<script>
import miniToastr from 'mini-toastr'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
import Multiselect from 'vue-multiselect'
miniToastr.init()
export default {
  components: {
    Multiselect
  },
  data () {
    return {
      storelist: [{ ID: 0, Code: '', Name: '' }],
      paymenttypeList: [], // 付款類型
      periodList: [],
      sdate: '',
      edate: '',
      sdate_take: '',
      edate_take: '',
      payment: 0,
      store: '', // 門市
      processtype: '0',
      paymenttype: '0',
      periodID: 0,
      payed: '0',
      mobile: '',
      ordercode: '',
      takeType: '0', // 內用外帶
      takeNumber: '',
      orderlist: [],
      currentPage: 1,
      perpage: 20,
      count: 0,
      startRowNum: 0,
      endRowNum: 0,
      queryBrandsCode: "MWD",
      selectListBrands: [], // 品牌下拉選單

      md_item: {
        orderID: 0,
        orderCode: '',
        refundTitle: '',
        refundMemo: '',
        password: ''
      },
      md_detail: {
        detailTitle: '',
        RefundID: '',
        RefundMemo: '',
        RefundTime: '',
        RefundBy: '',
        RefundFrom: '',
        ErrorTime: '',
        ErrorMemo: '',
        Payed: ''
      },
      md_meal: {
        code: '',
        num: '',
        detail: [
          {
            sideMeal: [],
            add: [],
            link: []
          }
        ],
        discount: 0,
        discountList: [
          {
            id: '',
            type: '',
            name: '',
            price: ''
          }
        ]
      },
      valid_memo: '',
      valid_password: '',

      nowHour: 0
    }
  },
  created () {
    this.setdate()
    this.getpost()
    this.queryPeriodList()
    this.querySelectListData()
    this.querySelectListBrands()
    this.FunctionPermission = getFunctionPermission('F32') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
    this.nowHour = new Date().getHours()
  },
  methods: {
    onReady (instance) {
      this.instances.push(instance)
    },
    changePage (page) {
      this.currentPage = page
      this.getinformation()
    },
    btnQuery () {
      this.currentPage = 1
      this.getinformation()
    },
    queryPeriodList () {
      // 餐期
      axios
        .post(API_URL + '/web/ordermanage/period/v1', {
          status: 0
        })
        .then(response => {
          this.periodList = response.data.data
          this.$parent.Loading = false
        })
        .catch(error => {
          this.periodList = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
        })
    },
    getinformation () {
      if (this.store == null) {
        this.store = ''
      }
      if (this.edate !== '') {
        if (this.sdate > this.edate) {
          miniToastr.error('請選擇正確的日期區間')
          return
        }
      }
      if (this.sdate_take > this.edate_take) {
        miniToastr.error('請選擇正確的日期區間')
        return
      }
      if (this.sdate_take === '' || this.edate_take === '') {
        miniToastr.error('請輸入取餐日期')
        return
      }
      // 計算天數
      var d1 = Date.parse(new Date(this.sdate))
      var d2 = Date.parse(new Date(this.edate))
      var day = parseInt((d2 - d1) / (1000 * 60 * 60 * 24))
      if (day >= 15) {
        miniToastr.error('訂餐日期區間超過15日')
        return
      }
      var d1_take = Date.parse(new Date(this.sdate_take))
      var d2_take = Date.parse(new Date(this.edate_take))
      var day_take = parseInt((d2_take - d1_take) / (1000 * 60 * 60 * 24))
      if (day_take >= 15) {
        miniToastr.error('取餐日期區間超過15日')
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/ordermanage/list', {
        sdate: this.sdate,
        edate: this.edate,
        sdate_take: this.sdate_take,
        edate_take: this.edate_take,
        store: this.store.ID,
        processtype: Number(this.processtype),
        paymenttype: Number(this.paymenttype),
        payed: this.payed,
        mobile: this.mobile,
        periodID: Number(this.periodID),
        takeType: this.takeType,
        takeNumber: this.takeNumber,
        ordercode: this.ordercode,
        toPage: this.currentPage,
        perPage: this.perpage,
        brandCode: this.queryBrandsCode,
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.orderlist = response.data.data
            this.count = (response.data.count === undefined) ? 0 : response.data.count
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.perpage * (this.currentPage - 1) + 1
            this.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.perpage > response.data.count) ? response.data.count : (this.currentPage * this.perpage) >= response.data.count ? response.data.count : this.currentPage * this.perpage
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    },
    setdate () {
      var today = new Date()
      var todaymon = today.getMonth() + 1
      if (todaymon < 10) {
        todaymon = '0' + todaymon
      }

      var date = new Date()
      date.setMonth(date.getMonth())
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.sdate_take = year + '-' + todaymon + '-' + day
      this.edate_take = year + '-' + todaymon + '-' + day
    },
    getpost () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/getallstores/v1', {
        brandCode: this.queryBrandsCode,
      })
        .then((response) => {
          if (response.data.result === '0000') {
            var plist = []
            var list = response.data.data
            list.forEach(function (arrRole, Index) {
              arrRole.Districts.forEach(function (arrRole1, Index1) {
                if (arrRole1.District === '全部區域') {
                  if (arrRole1.Stores) {
                    arrRole1.Stores.forEach(function (arrRole2, Index2) {
                      plist.push(arrRole2)
                    })
                  }
                }
              })
            })
            this.storelist = plist
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '資料讀取異常')
          this.$parent.Loading = false
        })
    },
    querySelectListData () {
      // 支付工具
      axios
        .post(API_URL + '/web/getpayment/v1', {
          status: 0
        })
        .then(response => {
          this.paymenttypeList = response.data.data
          this.$parent.Loading = false
        })
        .catch(error => {
          this.selectListPosType = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    showDetail (item) {
      this.md_detail = item
      this.md_detail.detailTitle = '訂單-' + item.Code
      this.$refs.mdDetail.show()
    },
    showMeal (item) {
      if (this.$parent.Loading === true) {
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/ordermanage/detail', {
        orderCode: item
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.md_meal = response.data.data
            this.$refs.mdMeal.show()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '顯示明細失敗')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.$parent.Loading = false
          miniToastr.error(error.message, '顯示明細失敗')
        })
    },
    detailCancel () {
      this.$refs.mdDetail.hide()
    },
    showEdit (item) {
      this.md_item.refundMemo = ''
      this.md_item.password = ''
      this.valid_password = ''
      this.valid_memo = ''
      this.md_item.orderID = item.ID
      this.md_item.orderCode = item.Code
      this.md_item.refundTitle = '訂單退款-' + item.Code
      this.$refs.mdEdit.show()
    },
    showEditCancel (item) {
      this.md_item.refundMemo = ''
      this.md_item.password = ''
      this.valid_password = ''
      this.valid_memo = ''
      this.md_item.orderID = item.ID
      this.md_item.orderCode = item.Code
      this.md_item.refundTitle = '訂單取消-' + item.Code
      this.$refs.mdEditCancel.show()
    },
    editClose () {
      this.$refs.mdEdit.hide()
    },
    editCancelClose () {
      this.$refs.mdEditCancel.hide()
    },
    editConfirm (type) {
      var typeName = ''
      if (type === '') {
        typeName = '退款'
      } else {
        typeName = '取消'
      }
      this.valid_errMsg = false
      if (!this.md_item.refundMemo) {
        this.valid_errMsg = true
        this.valid_memo = typeName + '原因不可為空'
      } else {
        this.valid_memo = ''
      }
      if (!this.md_item.password) {
        this.valid_errMsg = true
        this.valid_password = '密碼不可為空'
      } else {
        this.valid_password = ''
      }
      if (this.valid_errMsg) {
        this.$parent.verificationErrMsg()
        return
      }

      if (type === '') {
        this.edit()
      } else {
        this.Cancel()
      }
    },
    edit () {
      if (this.$parent.Loading === true) {
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/ordermanage/refund', {
        orderID: this.md_item.orderID,
        orderCode: this.md_item.orderCode,
        password: this.md_item.password,
        refundMemo: this.md_item.refundMemo
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('修改成功')
            this.$refs.mdEdit.hide()
            this.getinformation()
          } else if (response.data.result === '0101') {
            miniToastr.error('密碼錯誤')
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '退款失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.$parent.Loading = false
          miniToastr.error(error.message, '新增補點失敗')
        })
    },
    Cancel () {
      if (this.$parent.Loading === true) {
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/ordermanage/cancel', {
        orderID: this.md_item.orderID,
        orderCode: this.md_item.orderCode,
        password: this.md_item.password,
        refundMemo: this.md_item.refundMemo
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('取消成功')
            this.$refs.mdEditCancel.hide()
            this.getinformation()
          } else if (response.data.result === '1428') {
            miniToastr.error(response.data.message, '取消失敗')
            this.$refs.mdEditCancel.hide()
            console.log('訂單已入機，請從POS取消。')
            this.getinformation()
          } else if (response.data.result === '0101') {
            miniToastr.error('密碼錯誤')
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '退款失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.$parent.Loading = false
          miniToastr.error(error.message, '新增補點失敗')
        })
    },
    nameWithLang ({ Code, Name }) {
      return `${Code} — ${Name}`
    }
  },
  watch: {
    queryBrandsCode(selectedBrandCode) {
      if (selectedBrandCode) {
      this.getpost()
      }
    }
  },
  filters: {
    formatFullDate: function (date) {
      if (!date) {
        return ''
      }
      var d = new Date(date)
      var year = d.getFullYear()
      var mon =
        d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
      var min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
      return year + '/' + mon + '/' + day + ' ' + hour + ':' + min
    }
  }
}
</script>
<style scoped>
  .box-shadow {
    box-shadow: 0px 0px 1px 1px #cfcfcf;
  }
  .font_text {
    font-size: 19px;
    margin: 6px 0 7px;
  }
  .icon_img {
    height: 100%;
    padding: 0;
    margin: -2px;
  }
  .text-top {
    vertical-align: top;
  }
  #mytable > tbody > tr > td {
    vertical-align: middle;
    /* text-align: center; */
    height: 59px;
 }

</style>



// WEBPACK FOOTER //
// src/pages/order/manage/List.vue